import moment from 'moment';


const formatoDate2Fecha = (date) => {
  return moment(date).format('DD/MM/YYYY');
};
const formatoFecha2Date = (fecha) => {
  return moment(fecha, 'DD/MM/YYYY').format('YYYY-MM-DD');
}
const formatoFecha2Daterange = (fecha) => {
  return moment(fecha, 'DD/MM/YYYY').format('DD-MM-YYYY');
}
const formatoFechaHora = (date) =>{
  return moment(date).format('DD/MM/YYYY HH:mm:ss');
}
const last30DaysRange = () => {
  return {
    startDate: moment().subtract(30, 'days').format('DD/MM/YYYY'),
    endDate: moment().format('DD/MM/YYYY'),
  };
}
export default {
  methods: {
    formatoDate2Fecha,
    formatoFecha2Date,
    formatoFecha2Daterange,
    formatoFechaHora,
    last30DaysRange,
  },
}